// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/" + (chunkId === 96 ? "vendors" : chunkId) + "." + {"96":"23aeb36caa3f058be134","922":"35cb45c1b6da0f9f433f"}[chunkId] + ".js";
};